@if (!isAdminArea && !isStandaloneAuthPage) {
  <header class="site-header">
    <nav class="site-nav">
      <div class="site-nav__inner">
        <a routerLink="/" (click)="closeMenu()" class="site-brand" aria-label="خانه تولیدی">
          <span class="site-brand__logo" aria-hidden="true">T</span>
          <span>تولیدی</span>
        </a>
        <div class="site-nav__links">
          <a routerLink="/" routerLinkActive="site-nav__link--active" [routerLinkActiveOptions]="{ exact: true }"
          class="site-nav__link">خانه</a>
          <app-mega-menu></app-mega-menu>
          <a routerLink="/shop" routerLinkActive="site-nav__link--active" class="site-nav__link">فروشگاه</a>
          <!-- Dropdown: deals + top + shipping -->
          <div class="site-nav__dropdown">
            <button type="button" class="site-nav__link site-nav__dropdown-toggle">
              بیشتر
              <svg class="site-nav__chevron" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            <div class="site-nav__dropdown-panel">
              <a routerLink="/deals" class="site-nav__dropdown-item site-nav__dropdown-item--deals">
                <span aria-hidden="true">🔥</span> شگفت‌انگیزها
              </a>
              <a routerLink="/top-performers" class="site-nav__dropdown-item site-nav__dropdown-item--top">
                <span aria-hidden="true">🏆</span> برترین‌ها
              </a>
              <a routerLink="/shipping" class="site-nav__dropdown-item site-nav__dropdown-item--shipping">
                <span aria-hidden="true">📦</span> روش‌های ارسال
              </a>
              <a routerLink="/contact" class="site-nav__dropdown-item site-nav__dropdown-item--contact">
                <span aria-hidden="true">✉️</span> تماس با ما
              </a>
            </div>
          </div>
        </div>
        <app-search-autocomplete></app-search-autocomplete>
        <div class="site-nav__actions">
          @if (!currentUser) {
            <a routerLink="/auth" class="site-nav__btn site-nav__btn--ghost">ورود</a>
            <a routerLink="/auth" class="site-nav__btn site-nav__btn--primary">ثبت‌نام</a>
          }
          @if (currentUser) {
            <a routerLink="/cart" class="site-nav__btn site-nav__btn--ghost site-nav__btn--icon" aria-label="سبد خرید">🛒</a>
            <a routerLink="/profile" class="site-nav__btn site-nav__btn--ghost">پروفایل</a>
            @if (currentUser.role === 'Seller') {
              <a routerLink="/seller" class="site-nav__btn site-nav__btn--ghost">داشبورد فروشنده</a>
            }
            @if (currentUser.role === 'Admin') {
              <a routerLink="/admin" class="site-nav__btn site-nav__btn--ghost">پنل مدیریت</a>
            }
            <button type="button" (click)="logout()" class="site-nav__btn site-nav__btn--ghost site-nav__btn--logout">خروج</button>
          }
        </div>
        <button type="button" (click)="toggleMenu()" class="site-nav__burger"
          [attr.aria-expanded]="menuOpen" aria-controls="mobile-menu" aria-label="باز کردن منو">
          @if (!menuOpen) {
            <svg xmlns="http://www.w3.org/2000/svg" class="site-nav__burger-icon" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" stroke-width="1.8" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          }
          @if (menuOpen) {
            <svg xmlns="http://www.w3.org/2000/svg" class="site-nav__burger-icon" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" stroke-width="1.8" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
          }
        </button>
      </div>
    </nav>
    <!-- منوی موبایل: کشوی لغزنده از راست -->
    <div class="mobile-menu" [class.is-open]="menuOpen" (click)="closeMenu()">
      <aside id="mobile-menu" class="mobile-menu__drawer" [class.is-open]="menuOpen" (click)="$event.stopPropagation()">
        <div class="mobile-menu__head">
          <span class="mobile-menu__logo" aria-hidden="true">T</span>
          <div>
            <p class="mobile-menu__title">تولیدی</p>
            <p class="mobile-menu__subtitle">فروشگاهی برای حرفه‌ای‌ها</p>
          </div>
        </div>
        <div class="mobile-mega-menu">
          <app-mega-menu></app-mega-menu>
        </div>
        <div class="mobile-menu__links">
          <a routerLink="/" (click)="closeMenu()" class="mobile-nav-link">خانه <span aria-hidden="true">⌂</span></a>
          <a routerLink="/shop" (click)="closeMenu()" class="mobile-nav-link">فروشگاه <span aria-hidden="true">◈</span></a>
          <a routerLink="/deals" (click)="closeMenu()" class="mobile-nav-link mobile-nav-link--deals">🔥 شگفت‌انگیزها</a>
          <a routerLink="/top-performers" (click)="closeMenu()" class="mobile-nav-link mobile-nav-link--top">🏆 برترین‌ها</a>
          <a routerLink="/shipping" (click)="closeMenu()" class="mobile-nav-link mobile-nav-link--shipping">📦 ارسال</a>
          <a routerLink="/contact" (click)="closeMenu()" class="mobile-nav-link">تماس با ما <span aria-hidden="true">✉</span></a>
        </div>
        <div class="mobile-menu__footer">
          @if (!currentUser) {
            <a routerLink="/auth" (click)="closeMenu()" class="mobile-menu__cta">ورود / ثبت‌نام</a>
          }
          @if (currentUser) {
            <a routerLink="/profile" (click)="closeMenu()" class="mobile-nav-link">پروفایل <span aria-hidden="true">◎</span></a>
            <a routerLink="/orders" (click)="closeMenu()" class="mobile-nav-link">سفارش‌ها <span aria-hidden="true">☰</span></a>
            @if (currentUser.role === 'Seller') {
              <a routerLink="/seller" (click)="closeMenu()" class="mobile-nav-link">داشبورد فروشنده <span aria-hidden="true">↗</span></a>
            }
            @if (currentUser.role === 'Admin') {
              <a routerLink="/admin" (click)="closeMenu()" class="mobile-nav-link">پنل مدیریت <span aria-hidden="true">⚙</span></a>
            }
            <button type="button" (click)="logout()" class="mobile-menu__logout">خروج از حساب</button>
          }
        </div>
      </aside>
    </div>
  </header>
}

<main>
  <div [@routeAnimations]="prepareRoute(outlet)">
    <router-outlet #outlet="outlet"></router-outlet>
  </div>
  @if (!isAdminArea && !isStandaloneAuthPage) {
    <app-floating-cart></app-floating-cart>
  }
  @if (!isAdminArea && !isStandaloneAuthPage) {
    <app-bottom-nav></app-bottom-nav>
  }
</main>

@if (!isAdminArea && !isStandaloneAuthPage) {
  <footer class="site-footer">
    <div class="site-footer__inner">
      <div class="site-footer__grid">
        <div>
          <p class="site-footer__brand">تولیدی</p>
          <p class="site-footer__tagline">پلتفرم B2B برای خرید و فروش عمده.</p>
        </div>
        <div>
          <p class="site-footer__title">برای خریداران</p>
          <ul class="site-footer__list">
            <li><a routerLink="/shop" class="site-footer__link">فروشگاه</a></li>
            <li><a routerLink="/contact" class="site-footer__link">تماس با ما</a></li>
            <li><a routerLink="/cart" class="site-footer__link">سبد خرید</a></li>
          </ul>
        </div>
        <div>
          <p class="site-footer__title">برای فروشندگان</p>
          <ul class="site-footer__list">
            <li><a routerLink="/register" class="site-footer__link">ثبت نام فروشنده</a></li>
            <li><a routerLink="/seller" class="site-footer__link">داشبورد فروشنده</a></li>
            <li><a routerLink="/admin" class="site-footer__link">پنل مدیریت</a></li>
          </ul>
        </div>
        <div>
          <p class="site-footer__title">خبرنامه</p>
          <form (ngSubmit)="onNewsletterSubmit()" class="site-footer__form">
            <input type="email" name="newsletterEmail" [(ngModel)]="newsletterEmail" placeholder="ایمیل شما"
              class="site-footer__input" />
            <button type="submit" [disabled]="newsletterSubmitting" class="site-footer__submit">
              {{ newsletterSubmitting ? 'در حال ثبت…' : 'عضویت' }}
            </button>
          </form>
          @if (newsletterMessage) {
            <div class="site-footer__msg"
              [ngClass]="newsletterMessage.type === 'success' ? 'site-footer__msg--success' : 'site-footer__msg--error'">
              {{ newsletterMessage.text }}
            </div>
          }
        </div>
      </div>
      <div class="site-footer__bottom">
        © ۲۰۲۴ تولیدی — تمامی حقوق محفوظ است.
      </div>
    </div>
  </footer>
}
